(function () {
  function initSection(sectionEl) {
    /* ── Media gallery ── */
    const mediaItems = sectionEl.querySelectorAll('[data-pdp-media-item]');
    const thumbs     = sectionEl.querySelectorAll('.pdp-main__thumb');
    const prevBtn    = sectionEl.querySelector('[data-pdp-arrow="prev"]');
    const nextBtn    = sectionEl.querySelector('[data-pdp-arrow="next"]');

    let currentMediaIndex = 0;

    function updateMedia(mediaId) {
      if (!mediaId || !mediaItems.length) return;
      mediaItems.forEach((item, idx) => {
        const match = String(item.getAttribute('data-media-id')) === String(mediaId);
        item.hidden = !match;
        item.classList.toggle('is-active', match);
        if (match) currentMediaIndex = idx;
        else {
          const v = item.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(btn => {
        const isActive = String(btn.getAttribute('data-target-media-id')) === String(mediaId);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function shiftMedia(dir) {
      if (!mediaItems.length) return;
      currentMediaIndex = (currentMediaIndex + dir + mediaItems.length) % mediaItems.length;
      updateMedia(mediaItems[currentMediaIndex].getAttribute('data-media-id'));
    }

    if (prevBtn) prevBtn.addEventListener('click', e => { e.preventDefault(); shiftMedia(-1); });
    if (nextBtn) nextBtn.addEventListener('click', e => { e.preventDefault(); shiftMedia(1); });

    thumbs.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      updateMedia(btn.getAttribute('data-target-media-id'));
    }));

    const activeThumb = sectionEl.querySelector('.pdp-main__thumb.is-active');
    if (activeThumb) updateMedia(activeThumb.getAttribute('data-target-media-id'));

    /* ── Purchase options widget ── */
    const poWidget  = sectionEl.querySelector('#purchase-options');
    const form      = document.getElementById('pdp-main-form');
    const qtyInput  = form && form.querySelector('[name="quantity"]');
    const atcPriceEl = document.getElementById('pdp-atc-price-display');

    if (!poWidget || !form) return;

    const basePrice = parseInt(poWidget.getAttribute('data-base-price') || '0', 10);
    const cards     = poWidget.querySelectorAll('.po-card');
    const radios    = poWidget.querySelectorAll('.po-card__radio');

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        ? window.Shopify.currency.active : 'RON';
      if (sym === 'RON') return amount.replace('.', ',') + ' RON';
      if (sym === 'EUR') return '€' + amount;
      return amount + ' ' + sym;
    }

    function selectCard(radio) {
      const qty      = parseInt(radio.getAttribute('data-po-qty') || '1', 10);
      const plan     = radio.getAttribute('data-po-plan') || '';
      const discount = parseInt(radio.getAttribute('data-po-discount') || '0', 10);

      if (qtyInput) qtyInput.value = qty;
      /* Look up selling_plan fresh — Seal injects it after init */
      const planInput = form.querySelector('[name="selling_plan"]');
      if (planInput) planInput.value = plan;

      cards.forEach(c => c.classList.remove('po-card--selected'));
      const parentCard = radio.closest('.po-card');
      if (parentCard) parentCard.classList.add('po-card--selected');

      if (atcPriceEl) {
        const displayPrice = discount > 0
          ? Math.ceil(basePrice * (1 - discount / 100))
          : basePrice;
        atcPriceEl.textContent = formatMoney(displayPrice);
      }
    }

    radios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (this.checked) selectCard(this);
      });
    });

    cards.forEach(card => {
      card.addEventListener('click', function () {
        const radio = this.querySelector('.po-card__radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          selectCard(radio);
        }
      });
    });

    /* Initialise: select first card */
    const firstRadio = poWidget.querySelector('.po-card__radio');
    if (firstRadio) {
      firstRadio.checked = true;
      selectCard(firstRadio);
    }
  }

  function initAll() {
    const sections = document.querySelectorAll('.shopify-section');
    let found = false;
    sections.forEach(s => {
      if (s.querySelector('[data-pdp-media-item]') || s.querySelector('#purchase-options')) {
        initSection(s);
        found = true;
      }
    });
    if (!found) initSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    if (e.target) initSection(e.target);
  });
})();